import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-chat-child" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main__header" }
const _hoisted_4 = { class: "main__body" }
const _hoisted_5 = { class: "main__body--list" }
const _hoisted_6 = { class: "aside" }

import WidgetPanels from "@/components/widget/WidgetPanels.vue";
import CommonFilter from "@/components/common/CommonFilter.vue";
import CustomChildList from "@/components/custom/CustomChildList.vue";
import { useChatStore } from "@/features/chat/chat.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupChildView',
  setup(__props) {

const chatStore = useChatStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CommonFilter)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CustomChildList, {
            list: _unref(chatStore).chatList
          }, null, 8, ["list"])
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main__body--chat" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(WidgetPanels, { position: "vertical" })
    ])
  ]))
}
}

})